// Design system tokens (CSS custom properties)
import '@arctek-r5/design-system/css';

// ArcTek UI components (ark-button, ark-icon, ark-spinner, etc.)
import '@arctek-r5/ui';

// Stencil studio components (sysml-editor, sysml-diagram, etc.)
import { defineCustomElements } from '@arctek/sysml-studio/loader';
defineCustomElements(window);

// The MFE itself
import '../src/sysml-mfe.js';
